/*
 * @Author: Han
 * @Date: 2022-03-01 09:56:53
 * @LastEditors: Han
 * @LastEditTime: 2022-03-01 20:07:56
 * @FilePath: \console\src\http\moudules\caseClassManage.js
 */
import axios from '../axios'
// 获取列表
export const getCaseClassList = (data) => {
  return axios({
    url: '/backend/case_type/list',
    method: 'GET',
    data
  })
}
// 修改
export const editCaseClass = (data) => {
  return axios({
    url: '/backend/case_type/update',
    method: 'POST',
    data
  })
}
// 增加
export const addCaseClass = (data) => {
  return axios({
    url: '/backend/case_type/insert',
    method: 'POST',
    data
  })
}
// 隐藏
export const hideCaseClass = (data) => {
  return axios({
    url: '/backend/case_type/hide_or_open',
    method: 'POST',
    data
  })
}

// 案例详情
export const caseClassInfoList = (data) => {
  return axios({
    url: '/backend/case/queryCase',
    method: 'GET',
    data
  })
}
// 添加案例详情
export const addCaseClassInfo = (data) => {
  return axios({
    url: '/backend/case/insert',
    method: 'POST',
    data
  })
}
// 更新客户案例
export const editCaseClassInfo = (data) => {
  return axios({
    url: '/backend/case/update',
    method: 'POST',
    data
  })
}
// 删除案例
// 更新客户案例
export const delCaseClassInfo = (data) => {
  return axios({
    url: '/backend/case/delete',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/caseClassManage.js